<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="adc">
<h1 class="preface01">Other Books by Cathy Guisewite</h1>
<p class="center"><strong>Recent <em>Cathy</em><sup class="frac">®</sup> Collections</strong></p>
<p class="center">Food<br/>Love<br/>Mom<br/>Work<br/>Cathy Twentieth Anniversary Collection<br/>Shoes: Chocolate for the Feet<br/>I’d Scream Except I Look So Fabulous<br/>I Am Woman, Hear Me Snore<br/>Abs of Steel, Buns of Cinnamon<br/>Understanding the “Why” Chromosome<br/><br/></p>
<p class="center"><em><strong>Cathy<sup class="frac">®</sup></strong></em> <strong>Gift Books</strong><br/><br/></p>
<p class="center">Confessions to My Mother<br/>Like Mother, Like Daughter<br/>Commiserations<br/>Shop Till You Drop Then Sit Down and Buy Shoes<br/><br/></p>
<p class="center"><strong>Cookbook</strong></p>
<p class="center">Girl Food: Cathy’s Cookbook for the Weil-Balanced Woman (with Barbara Albright)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740799426_epub_adc_r1.vue?c9ede3a6